import { PRIVACY } from "@/data/content";

export default function Privacy() {
  return (
    <section className="pgwrap" style={{ maxWidth: 860 }}>
      <span className="pg-eyebrow">Legal</span>
      <h2 className="pg-h2">Privacy Policy</h2>
      <p className="pg-lead">How we collect, use and protect your personal and health information, in line with India’s Digital Personal Data Protection Act 2023.</p>
      <div className="legal-callout">Information shared during consultations is never used for marketing, sold, rented or traded.</div>
      <div className="legalbody">
        {PRIVACY.map(([h, p], i) => (
          <div key={i}>
            <h3>{i + 1}. {h}</h3>
            <p>{p}</p>
          </div>
        ))}
        <p style={{ fontSize: 12.5, color: "var(--slate)", marginTop: 18 }}>This is a design draft pending your reference document; final wording to be confirmed.</p>
      </div>
    </section>
  );
}
